import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../@shared/shared.module';

import { MaterialModule } from '@app/material.module';
import { ProfileConfirmationDialogComponent } from './profile-confirmation-dialog.component';
import { VideoPlayerModuleModule } from '@app/page-modules/video-player-module/video-player-module.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MaterialModule,
    SharedModule,
    VideoPlayerModuleModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  declarations: [ProfileConfirmationDialogComponent],
  exports: [ProfileConfirmationDialogComponent],
})
export class ProfileConfirmationDialogModule {}
